import { axiosGet, axiosPatch, axiosPost } from "./axiosService";
//  userProfile: `${baseUrl}/api/v1/user/profile`,
const url = "/user";

export const getUserProfile = () => axiosGet(`${url}/profile`);
export const patchUserPassword = (body) => axiosPatch(`${url}/password`, body);
export const postPasswordForget = (body) =>
  axiosPost(`${url}/password/forget`, body);
